var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("input", {
        ref: "excel-upload-input",
        staticClass: "excel-upload-input",
        attrs: { type: "file", accept: ".xlsx, .xls" },
        on: { change: _vm.handleClick }
      }),
      _vm._v(" "),
      _c(
        "el-button",
        {
          attrs: { loading: _vm.loading, size: "mini", type: "primary" },
          on: { click: _vm.handleUpload }
        },
        [_vm._t("default")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f095c5f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f095c5f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/UploadExcel/index.vue
// module id = null
// module chunks = 